var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReceiptMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5833 6.24992V8.77075C23.5833 10.4166 22.5416 11.4583 20.8957 11.4583H17.3333V4.177C17.3333 3.02075 18.2812 2.08325 19.4374 2.08325C20.5728 2.09367 21.6145 2.552 22.3645 3.302C23.1145 4.06242 23.5833 5.10409 23.5833 6.24992Z",
    stroke: "#1B3F7A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 7.29159V21.8749C2.75 22.7395 3.72917 23.2291 4.41667 22.7083L6.19791 21.3749C6.61458 21.0624 7.19791 21.1041 7.57291 21.4791L9.30208 23.2187C9.70833 23.6249 10.375 23.6249 10.7812 23.2187L12.5312 21.4687C12.8958 21.1041 13.4792 21.0624 13.8854 21.3749L15.6667 22.7083C16.3542 23.2187 17.3333 22.7291 17.3333 21.8749V4.16659C17.3333 3.02075 18.2708 2.08325 19.4167 2.08325H7.95833H6.91667C3.79167 2.08325 2.75 3.94784 2.75 6.24992V7.29159Z",
    stroke: "#1B3F7A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M7.177 10.4167H12.9062",
    stroke: "#1B3F7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiptMobile);
export default __webpack_public_path__ + "static/media/receipt-mobile.fcc1a45c951d0afd2d5c92eb992ebe21.svg";
export { ForwardRef as ReactComponent };